import { Instance, types } from "mobx-state-tree";
import { AgentGroup as ApiAgentGroup } from "@closerplatform/spinner-openapi";

export const AgentGroup = types.model("AgentGroup", {
  id: types.identifier,
  name: types.string,
  tagIds: types.array(types.string),
  tagGroupIds: types.array(types.string),
  adviserIds: types.array(types.string)
});

export class AgentGroupModel {
  public static fromApiDTO(agentGroup: ApiAgentGroup) {
    return AgentGroup.create({
      id: agentGroup.id,
      name: agentGroup.name,
      tagGroupIds: agentGroup.tagGroups,
      tagIds: agentGroup.tags,
      adviserIds: agentGroup.advisers
    });
  }
}
export interface IAgentGroup extends Instance<typeof AgentGroup> {}
